const middleware = {}

middleware['deviceRedirect'] = require('../middleware/deviceRedirect.js')
middleware['deviceRedirect'] = middleware['deviceRedirect'].default || middleware['deviceRedirect']

middleware['getSEO'] = require('../middleware/getSEO.js')
middleware['getSEO'] = middleware['getSEO'].default || middleware['getSEO']

middleware['getSiteInfo'] = require('../middleware/getSiteInfo.js')
middleware['getSiteInfo'] = middleware['getSiteInfo'].default || middleware['getSiteInfo']

middleware['storePublicCp'] = require('../middleware/storePublicCp.js')
middleware['storePublicCp'] = middleware['storePublicCp'].default || middleware['storePublicCp']

export default middleware
